import { put, takeLatest } from "redux-saga/effects";
import {
  CREATE_NEW_USER,
  CREATE_NEW_USER_INIT,
  CREATE_NEW_USER_SUCCESS,
  CREATE_NEW_USER_FAILED,
  GET_ALL_USERS,
  GET_ALL_USERS_INIT,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_FAILED,
  GET_USER_DETAIL,
  GET_USER_DETAIL_INIT,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_FAILED,
  UPDATE_USER_DETAIL,
  UPDATE_USER_DETAIL_INIT,
  UPDATE_USER_DETAIL_SUCCESS,
  UPDATE_USER_DETAIL_FAILED,
  UPDATE_USER_STATUS,
  UPDATE_USER_STATUS_INIT,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_FAILED,
  GET_USER_ROLES,
  GET_USER_ROLES_INIT,
  GET_USER_ROLES_SUCCESS,
  GET_USER_ROLES_FAILED,
} from "./constants";
import { postUtil, getUtil, putUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";

export function* createNewUser({ payload, onSuccess }) {
  yield put({ type: CREATE_NEW_USER_INIT });
  try {
    const res = yield postUtil(`${API.CreateUser}`, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: CREATE_NEW_USER_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: CREATE_NEW_USER_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getAllUsers() {
  yield put({ type: GET_ALL_USERS_INIT });
  try {
    const res = yield getUtil(`${API.GetAllUser}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_ALL_USERS_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_ALL_USERS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getUserDetail({ id }) {
  yield put({ type: GET_USER_DETAIL_INIT });
  try {
    const res = yield getUtil(`${API.GetUser}?userId=${id}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_USER_DETAIL_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_USER_DETAIL_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* updateUserDetail({ payload, onSuccess }) {
  yield put({ type: UPDATE_USER_DETAIL_INIT });
  try {
    const res = yield putUtil(`${API.UpdateUserDetail}`, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_USER_DETAIL_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: UPDATE_USER_DETAIL_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* updateUserStatus({ payload, onSuccess }) {
  yield put({ type: UPDATE_USER_STATUS_INIT });
  try {
    const res = yield putUtil(`${API.UpdateUserStatus}`, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_USER_STATUS_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: UPDATE_USER_STATUS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getUserRoles() {
  yield put({ type: GET_USER_ROLES_INIT });
  try {
    const res = yield getUtil(`${API.GetRoles}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_USER_ROLES_SUCCESS, payload: data.result.items });
    } else {
      yield put({ type: GET_USER_ROLES_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* createNewUsers() {
  yield takeLatest(CREATE_NEW_USER, createNewUser);
  yield takeLatest(GET_ALL_USERS, getAllUsers);
  yield takeLatest(GET_USER_DETAIL, getUserDetail);
  yield takeLatest(UPDATE_USER_STATUS, updateUserStatus);
  yield takeLatest(UPDATE_USER_DETAIL, updateUserDetail);
  yield takeLatest(GET_USER_ROLES, getUserRoles);
}
